<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M6.62345 4.77563V16.4557H14.1206L17.8749 20V16.4546H19V4.77563H6.62345ZM8.2224 6.28602H17.3999V14.9464H16.2759V16.3541L14.7833 14.9464H8.2224V6.2849V6.28602Z"
        ></path>
        <path
            d="M1 0V11.6801H2.12514V15.2244L5.87938 11.6801H7.46589V10.1708H5.21787L3.72522 11.5785V10.1708H2.60121V1.51038H11.7787V5.49007H13.3788V0L1 0Z"
        ></path>
    </svg>
</template>

<script>
export default {
    name: 'ChatSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
